import { addLabelArray } from "helpers/addLabelArray"

export const couponsTypes = {
  GET_COUPONS: "GET_COUPONS",
  SELECT_COUPON: "SELECT_COUPON",
  APPLY_COUPON: "APPLY_COUPON",
  SET_COUPONS_FILTERS: "SET_COUPONS_FILTERS"
}

const {
  GET_COUPONS,
  SELECT_COUPON,
  SET_COUPONS_FILTERS
} = couponsTypes

const initialState = {
  coupons: [],
  coupon: {},
}

export const couponsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_COUPONS:
      const addLabel = payload.map(cp => {
        return {
          ...cp,
          label: `${cp.name} - ${cp.code}`,
          value: cp.id
        }
      })
      return {
        ...state,
        coupons: addLabel
      }
    case SELECT_COUPON:
      return {
        ...state,
        coupon: payload
      }
    case SET_COUPONS_FILTERS:
      return {
        ...state,
        [payload.key]: payload.data,
      }
    default:
      return state
  }
}